const globalMsg = {
  en: {
    common: {
      home: 'Home',
      back: 'Back',
      next: 'Next',
      empty: 'Empty',
      multimedia: 'Multimedia',
      audio: 'Audio',
      video: 'Video',
      image: 'Image(s)',
      file: 'File',
      pdf: 'Pdf',
      text: 'Text',
      test: 'Test',
      link: 'Link',
      newTab: 'Open in a New Tab',
      move: 'Move',
      copy: 'Copy',
      loading: 'Loading',
      loadingPresentationMode: 'Loading Presentation Mode Session',
      loadingFromFileSystem: 'Loading {filename} from your local file system.',
      loadingFromServerInfo: 'Downloading {filename} to your local file system and loading it here in the viewer.',
      loadingFromServerProgressInfo: '{downloadAmount}MB/{downloadTotalSize}MB, {downloadSpeed}Mb/s, {progress}%',
      saving: 'Saving',
      cancel: 'Cancel',
      save: 'Save',
      finish: 'Finish',
      insert: 'Insert',
      description: 'Description',
      name: 'Name',
      deleting: 'Removing',
      edit: 'Edit',
      remove: 'Delete',
      reorder: 'Reorder',
      processing: 'Processing',
      add: 'Add',
      addPage: 'Add page',
      tutoring: 'Tutoring',
      myCourses: 'My Courses',
      content: 'Content',
      prev: 'Prev',
      tasks: 'Tasks',
      currentLessons: 'Current Lessons',
      recentNotes: 'Recent Notes',
      institution: 'Institution',
      register: 'Register',
      myContent: 'My Content',
      myClasses: 'My Classes',
      pleaseSelect: 'Select...',
      comingSoon: 'Coming soon',
      pleaseConfirm: 'Please confirm',
      accept: 'Accept',
      submit: 'Submit',
      done: 'Done',
      seeMore: 'See more',
      addReponse: 'Add Response',
      sendingResponse: 'Sending Response',
      startAt: 'Start at',
      endAt: 'End at',
      search: 'Search',
      selectAll: 'Select all',
      information: 'Information',
      courses: 'Courses',
      users: 'Users',
      date: 'Date',
      hour: 'Hour',
      tryAgain: 'Try again',
      today: 'Today',
      tomorrow: 'Tomorrow',
      to: 'To',
      at: 'At',
      of: 'Of',
      from: 'From',
      join: 'Join',
      select: 'Select',
      youtube: 'Youtube',
      upload: 'Upload',
      searching: 'Searching',
      response:'Response',
      notFound: 'Not found',
      new:'New',
      student: 'student',
      loadingCourses:'Loading courses',
      loadingStudents:'Loading students',
      download:'Download',
      downloading: 'Downloading',
      generate:'Generate',
      feedback:'Feedback',
      schoolWork: 'Tasks',
      show: 'Show',
      allCourses: 'All Courses',
      create: 'Create',
      creating: 'Creating',
      view: 'View',
      close: 'Close',
      section: 'Section',
      folder: 'Folder',
      fullScreen: 'Full Screen',
      minimize: 'Minimize',
      loadingMembers: 'Loading members',
      courseMaterial: 'Subject Library',
      title: 'Title',
      actions: 'Actions',
      currentSelection: 'Current Selection',
      removeSelection: 'Remove Selection',
      selectAllContent: 'Select all Content',
      startPage: 'Start Page',
      endPage: 'End Page',
      endPageIsLowerThanStartPage: 'End page is lower than start page',
      invalidStartPage: 'Invalid start page',
      error: 'Error',
      retrievingEpubInfo: 'Retrieving EPUB information',
      initialChapter:'Initial chapter',
      finalChapter: 'Final  chapter',
      allContent: 'All content',
      fromStart: 'From {type} {start} to the end',
      fromStartToEnd: 'From {type} {start} to {type} {end}',
      page: 'page',
      send: 'Send',
      saved: 'Saved',
      write: 'Write',
      subdeck: 'Sub Deck',
      showSideBar: 'Show sidebar',
      hideSideBar: 'Hide sidebar',
      hangUp: 'Hang Up',
      startCall: 'Starting call',
      answerCall: 'Answer Call',
      wasMuted: 'You have been muted by the teacher.',
      wasKickouted: 'You have been kicked off the call.',
      wasGrantToCall: 'You have grant access to call in the {className}',
      callError: 'Call error',
      connErrorCall: 'The call has been terminated due to communication problems.',
      reconnectCall: 'Reconnect to the call',
      callWitoutTeacher: 'You’ve joined the call. The teacher hasn’t connected yet.',
      callEndedByTeacher: 'The teacher \'{fullName}\' has left the call',
      muteCall: 'Mute',
      unmuteCall: 'Unmute',
      kick: 'Kickout',
      kickouted: 'User banned from the call (click to allow access)',
      muteCallAll: 'Mute everyone on this call',
      unMuteCallAll: 'Unmute everyone on this call',
      lockCall: 'Lock the call (no one else can login on this call)',
      unlockCall: 'Unlock the call (anyone can login to this call)',
      speakers: 'Speakers',
      cameraCall: 'Turn on/off Camera',
      showVideoScreen: 'Show call',
      infoCall: 'Call information',
      moderator: 'Moderator',
      infoCallMember: '{callMembers} of {classMembers} participants',
      memberOfClass: 'Class members {classMembers} | On call {callMembers}',
      confirmSavePdf: 'Are you sure you want to submit your task?',
      confirmExit: 'Are you sure you want to leave?',
      noDescription: 'No description available',
      noTitle: 'No title available',
      exit: 'Exit',
      created: 'Created: ',
      sent: 'Sent',
      sendingFeedback: 'Sending feedback...',
      menu: 'Menu',
      refresh: 'Refresh',
      type: 'Type',
      pageCamel: 'Page',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      print: 'Print',
      otherFilesApp: 'Other Files',
      presentSlide: 'Present',
      zipLesson: 'ZIP Lesson',
      deck: 'Deck',
      reload: 'Reload',
      applicationLoading: 'Please wait while the application is loading...',
      clean: 'Clear',
      ok: 'Ok'
    },
    inactivityTimeout: {
      modalTitle: 'Logout Warning',
      modalOption1: 'I\'m here',
      modalOption2: 'Sign Out',
      modalBody1: 'You\'ve been inactive for a while. Please confirm your status, otherwise you will be logged out in:',
      modalBody2: 'Are you still there?'
    },
    footer: {
      termsAndConditions: 'Terms & conditions',
      aboutUs: 'About Us',
      privacyPolicy: 'Privacy Policy',
      helpArea: 'Help Area',
      contactUs: 'Contact Us'
    },
    errors: {
      required: 'This field is required',
      emailValid: 'E-mail must be valid',
      url: 'The url format is invalid',
      maxLength: 'The text is above than the max length of the field',
      maxLengthData: 'The text is above than the max length of the field [{max}]',
      minLengthData: 'The text is below the minimum length of the field [{min}]',
      dropzoneTimeout: 'Sorry, the file upload took longer than expected. Please try again',
      errorSaving: 'Sorry, there was an error trying to save the changes, please try again.',
      ups: 'Whoops!',
      uplodingInformation: 'Error sending information, please try again',
      minDateValue: 'The date can \'t be less than {min}',
      minDateCustom: 'The date can \'t be less than: ',
      number: 'Only numbers',
      load: 'There was an error loading this section. Try again.',
      between: 'The value should be between {min} and {max}',
      errorLoading: 'Sorry, there was an error trying to load the data, please try again.',
      errorConnCallServer: 'Sorry, there was an error trying to connect to the call server [{reason}]',
      warningTeacherNotInCall: 'Sorry, this call has not been started by a teacher',
      sipError: 'Sorry, communication problems with the call server.',
      sipGeneralError: 'Sorry, communication problems with the call.',
      errorNoExtensionOnCall: 'Sorry, No extensions available for conference',
      errorCallNotSupported: 'Sorry, this browser does not support calls. Please try again with another browser, or update this one. Your current version is ',
      notPermissionsGranted: 'Please restart the call but grant the permissions to the device.',
      minValue: 'The value should be greater than {min}',
      maxValue: 'The maximum value should be {max}',
      codes: {
        ERR002: 'Sorry, there was an error trying to save the changes, please try again.',
        SD001: 'The start date must be a date before to the end date',
        SD002: 'The requested school day overlaps with the another school calendar, please verify this.',
        CS002: 'Current due date is before that start date',
        CS003: 'The last date to submit must be a date after or equals to the due date',
        CB001 : 'The Start Hour is invalid',
        CB002 : 'The End Hour is invalid',
        CB003 : 'The start hour must be before the end hour.',
        CB004 : 'Working day not enabled on class',
        CB005 : 'This time or days has conflicts with others blocks. Please verify.',
        CB006 : 'Class has a different schedule than other Class',
        CB007 : 'There are Schedule entries in working days that you are trying to remove',
        CB008 : 'This schedule has blocks out of the range selected. Please verify',
        HW001 : 'The assignment has been deleted. Please reload it'
      },
      networkError: 'Sorry, there was an error connecting to the server.',
      offlineNetworkError: 'There was a connection error. You will continue to work offline until the connection is reestablished.',
      tryingReconnect: 'Please wait, trying to reconnect.',
      expirationHomework: 'The task cannot be edited after its due date.',
      manuallyReconnect: 'Click to reconnect, the app did not reconnect automatically due to inactivity.',
      connectBtn: 'Connect',
      communicationServer: 'There has been a communication error. Please accept to continue.' ,
      errorLoadingPublicPM: 'There has been a connection error. Please press the Reload button.',
      errorGetData: 'Sorry, there was an error trying to get the data. Try again.',
      cameraNotAvailable: 'Camera not available'
    },
    menu: {
      drafts: 'Drafts',
      myClasses: 'My classes',
      courseCreation: 'Course creation',
      contentCreation: 'Content creation',
      shareWithMe: 'Share with me',
      classes: 'Classes',
      myContent: 'My Content',
      home: 'Home',
      resources: 'Resources',
      institutions: 'Institutions',
      purchased: 'Purchased',
      bookstore: 'Bookstore',
      tutors: 'Tutors',
      login: 'Login',
      about: 'About us',
      contact: 'Contact us',
      faq: 'FAQ',
      training: 'Training',
      myTools: 'My tools',
      meetings:'Present',
      calls: 'Calls',
      customize:'Customize',
      noClasses:'No classes available',
      tohaina:'Conference',
      sharedDocument:'Shared Document',
      whiteboard:'Whiteboard',
      presentationMode: 'Presentation Mode',
      sync: 'Synchronize',
      present: 'Present',
      call: 'Call',
      join: 'Join',
      sheet:'Sheet',
      slide:'Slide',
      popupBlocked: 'The meeting window has been blocked by the browser, please enable popups in your settings',
      courseViewer: 'Course Viewer',
      studentReadOnly: 'Read Only',
      onToggle: 'Disable to allow students to edit the documents',
      offToggle: 'Enable so students cannot edit the documents',
      meetingTools: 'Tools',
      transparency: 'Transparency',
      onTransparencyToggle: 'Disable document editing',
      offTransparencyToggle: 'Enable document editing',
      all: 'All',
      main: 'Main',
      tasks: 'Tasks',
      menu: 'Menu'
    },
    homeworks: {
      homework:'Student assignment',
      homeworkPoints:'Total number of problems',
      homeworkWeight:'Grade Weight',
      homeworkPointsMessage: 'Total points for this task',
      homeworkWeightMessage: 'Weight of this task over the whole subject',
      homeworkResponseSent: 'Interactive activity response sent',
      homeworkResponseView: 'View interactive activity response sent',
      homeworks: 'Interactive Activities',
      loadingHomeworks:'Loading Interactive Activities',
      alreadyGraded:'Already graded',
      setGrade:'Set grade',
      noCoursesWithHomeworks:'You don\'t have subjects with Interactive Activities yet',
      addReponse: 'Add response',
      noHomeworks: 'No homeworks',
      notHomeworksStudent: 'This student doesn\'t have interactive activities in this subject now',
      notHomeworksSection: 'This interactive activity doesn\'t have students to check now',
      feedbackSent: 'Feedback sent',
      uploadFeedback:'Upload feedback',
      studentNotHomeworks: 'You don\'t have pending interactive activities in this subject',
      byStudents: 'By students',
      byActivities: 'By activities',
      sendAllAnnotations: 'Send with all annotations',
      sendOnlyMyAnnotations: 'Send only with my annotations',
      homeworkWithoutAnnotations: 'The task doesn’t have annotations yet',
      homeworkOnlyTeacherAnnotations: 'This task only has annotations from your teacher. Do you want to submit this task only with your teacher\'s annotations?',
      homeworkManyAnnotations: 'This task not only has annotations from you but also from your teacher. What do you want to do with these annotations?',
      cantOpenHomework: 'This task can not be opened with this version, please open it on the device where you started it',
      annotationsDeleteAll: 'This will delete everything you did. Are you sure you want to?',
      homeworkDraftNotAvailable: 'Homework draft is not available',
      removeCurrentPage: 'This action will delete all the markup you have done so far on the current page. Do you want to proceed?',
      documentStatus: 'Your document is being generated. This process could take several minutes; please check back later.',
      disconnected: 'Disconnected',
      empty: 'Without annotations',
      pendingAnswers: 'You have pending answers',
      wip: 'Work in progress',
      submitted: 'Submitted',
      noAvailable: 'Task not available',
      responseDraftStatus: 'Task in progress',
      feedbackDraftStatus: 'Feedback in progress',
      joinTooltip: 'Click to join collaborative task session',
      homeworkUpdated: 'Homework updated',
      newHomeworkVersionUploaded: '{fullName} just uploaded a new version of this task. Your board will be reloaded',
      someone: 'Someone',
      homeworkConflictVersion: 'You have been working offline in this device and we detected there are changes done on another session on {date}.\n What version would you like to keep?',
      remoteVersion: 'Keep what was done on another device',
      localVersion: 'Keep the version from this device',
      mergeVersions: 'Merge both versions',
      waitBackOnline: 'You are back online. Please wait a few seconds while we get you back into the session.',
      homeworkHistory: 'Version History',
      historyTitle: 'Version History - {name}',
      historyDisclamer: 'There are annotations pending synchronization. Reopen the task to synchronize them and enable versioning restore.',
      loadingItems: 'Loading items',
      noDataAvailable: 'No data available',
      history: {
        date: 'Date Time',
        source: 'Source',
        version: 'Version',
        actions: 'Actions',
      },
      sourceType: {
        autosave: 'Autosaved',
        overwrite: 'Overwritten',
        restore: 'Version restored',
        clean_all_annotations: 'All annotations cleared',
        clean_page_annotations: 'Page annotations cleared',
        web: 'Web',
        uwp: 'Windows',
        ios: 'iOS',
        web_save: 'Web - Save',
      },
      takeTextEditorControl: 'Edit Text',
      teacherEditingText: 'The teacher is editing',
      teacher: 'Teacher',
      student: 'Student',
      actionView: 'Preview',
      actionRestore: 'Restore version',
      questionActionRestore: 'Are you sure to restore the document to this version?',
      documentRestored: 'The document was successfully restored to version {versionId}',
      errorTitle: 'Oops!',
      errorDocumentRestored: 'Sorry, there was an error trying restoring the document',
      boardsAreSyncing: 'The boards are syncing. Please wait until they finish and try again.',
      boardsHavePendingAnnotations: 'The boards have pending annotations. Please wait until they are sent to server and try again.',
      conflictResolutionFailed: 'Conflict resolution failed. This will be reattempted when you are back online.',
      includeFeedback: 'Include the teacher\'s feedback when available',
      includeProblem: 'Include the problem statement',
      reportOptionsTitle: 'Report options',
      reportOptionsMessage: 'Please select the options to include in the report:',
    },
    teacherPortal: {
      calendar: 'Calendar',
      im: 'IM',
      grades: 'Grades',
      tasks: 'Tasks',
      meetings: 'Meetings',
      calls: 'Calls'
    },
    edupad: {
      synchronizing: 'Synchronizing data with the server',
      errorMessage: 'Could not synchronize to the collaborative server',
      docDeletedTitle: 'Document Deleted',
      docDeleted: 'The document has been deleted. Please reload the assigment.',
      verificationFailedReconnect: 'User verification failed. Please reconnect to synchronize the document.',
      verificationFailed: 'User verification failed',
      connectionErrorTitle: 'Connection Error',
      viewHistory:'View version history',
      unauthenticatedUser: 'Unauthenticated user',
      networkStatus:'Network status',
      historyTitle: 'Choose your version',
      chooseVersion: 'Choose a version',
      restore: 'Restore',
      restoring: 'Restoring version {version}',
      remoteRestoring: 'The user \'{username}\' is restoring version {version}',
      remoteRestored: 'The version {version} was restored by user \'{username}\'',
      errorRestoring: 'Could not restore the selected version',
      confirmRestore: 'Restoring this version will overwrite your current version. Are you sure?',
      noHistory: 'Current document has no history',
      loadingHistory: 'Loading history...',
      errorHistory: 'Unable to retrieve the document history',
      errorHistoryVersion: 'Unable to retrieve the document version \'{version}\'',
      erroLoadingMilestones: 'Unable to retrieve the document milestones',
      offline: 'Loading offline document',
      offlineEnd: 'You are now online. Synchronizing data',
      milestoneAutosaveLabel: 'Autosave',
      milestoneRestoredLabel: 'Restored',
      milestoneOverridedLabel: 'Overwrite',
      milestoneInitial: 'Initial',
      milestoneCurrent: 'Current',
      milestoneAutosave: 'Autosaved at \'{date}\'',
      milestoneOverride: 'Overrided by \'{user}\' at \'{date}\' ',
      milestoneRestore: 'Restored by \'{user}\' at \'{date}\'',
      showMilestones: 'Show milestones',
      placeholder: 'Start collaborating...'
    },
    drawItems: {
      pencil: 'Pencil',
      text: 'Text',
      pointer: 'Pointer',
      rectangle: 'Rectangle',
      hand: 'Hand',
      trash: 'Trash',
      circle: 'Circle',
      straightLine: 'Straight line',
      zoom: 'Zoom',
      opacity: 'Opacity',
      size: 'Size',
      whiteout: 'White-out',
      square: 'Square',
      ellipse: 'Ellipse',
      color: 'Color',
      shapes: 'Shapes',
      eraser: 'Eraser',
      undo: 'Undo',
      redo: 'Redo',
      removeCurrent: 'Remove current page',
      removeAll: 'Remove all',
      menu: 'Menu'
    },
    breadcrumbs: {
      home: 'Home',
      purchased: 'Purchased',
      subjects: 'Subjects',
      books: 'Books',
      courses: 'Courses',
      myContent: 'My content',
      all: 'All',
      templates: 'Templates'
    },
    error404: {
      404: '404',
      somethingBroken: 'Oops! Something is broken.',
      brokenReasons: 'Here\'s a list of possible reasons:',
      brokenReason1: 'Mistyped URL',
      brokenReason2: 'Copy-and-paste error',
      brokenReason3: 'Broken link',
      brokenReason4: 'Truncated link',
      brokenReason5: 'Moved content',
      brokenReason6: 'Deleted content',
      ifErrorPersists: 'If the error persist',
      contactUs: 'Contact Us',
      forSupport: 'for support.'
    }
  },
  es: {
    common: {
      home: 'Inicio',
      back: 'Atrás',
      next: 'Siguiente',
      empty: 'Vacío',
      multimedia: 'Multimedia',
      audio: 'Audio',
      video: 'Video',
      image: 'Imagen(es)',
      file: 'Archivo',
      pdf: 'Pdf',
      text: 'Texto',
      test: 'Prueba',
      link: 'Enlace',
      newTab: 'Abrir en una nueva pestaña',
      move: 'Mover',
      copy: 'Copiar',
      loading: 'Cargando',
      loadingPresentationMode: 'Cargando sesión del Modo Presentación',
      loadingFromFileSystem: 'Cargando {filename} desde tu sistema de archivos local.',
      loadingFromServerInfo: 'Descargando {filename} a tu sistema de archivos y cargándolo aquí en tu visor.',
      loadingFromServerProgressInfo: '{downloadAmount}MB/{downloadTotalSize}MB, {downloadSpeed}Mb/s, {progress}%',
      saving: 'Guardando',
      cancel: 'Cancelar',
      save: 'Guardar',
      insert: 'Insertar',
      description: 'Descripción',
      name: 'Nombre',
      deleting: 'Eliminando',
      edit: 'Editar',
      remove: 'Eliminar',
      reorder: 'Reordenar',
      processing: 'Procesando',
      add: 'Añadir',
      addPage: 'Añadir página',
      tutoring: 'Tutoring',
      myCourses: 'Mis cursos',
      content: 'Contenido',
      prev: 'Anterior',
      tasks: 'Tareas',
      currentLessons: 'Lecciones Actuales',
      recentNotes: 'Notas Recientes',
      institution: 'Institución',
      register: 'Registro',
      myContent: 'Mi Contenido',
      myClasses: 'Mis clases',
      pleaseSelect: 'Selecciona...',
      comingSoon: 'Próximamente disponible',
      pleaseConfirm: 'Por favor confirma',
      accept: 'Aceptar',
      submit: 'Enviar',
      done: 'Hecho',
      seeMore: 'Ver más',
      addReponse: 'Agregar Respuesta',
      sendingResponse: 'Enviando Respuesta',
      startAt: 'Inicia',
      endAt: 'Termina',
      search: 'Buscar',
      selectAll: 'Seleccionar todos',
      information: 'Información',
      courses: 'Cursos',
      users: 'Usuarios',
      date: 'Fecha',
      hour: 'Hora',
      tryAgain: 'Intentar de nuevo',
      today: 'Hoy',
      tomorrow: 'Mañana',
      to: 'Hasta',
      at: 'a las',
      of: 'De',
      from: 'Desde',
      join: 'Unirse',
      select: 'Seleccionar',
      youtube: 'Youtube',
      upload: 'Cargar',
      searching: 'Buscando',
      response: 'respuesta',
      notFound: 'No hay resultados',
      new:'Nuevo',
      student: 'estudiante',
      loadingCourses:'Cargando cursos',
      loadingStudents:'Cargando estudiantes',
      download:'Descargar',
      downloading: 'Descargando',
      generate:'Generar',
      feedback:'realimentación',
      schoolWork: 'Tareas',
      show: 'Mostrar',
      allCourses: 'Todos los Cursos',
      create: 'Crear',
      creating: 'Creando',
      view: 'Ver',
      close: 'Cerrar',
      section: 'Sección',
      folder: 'Carpeta',
      fullScreen: 'Pantalla completa',
      minimize: 'Minimizar',
      loadingMembers: 'Cargado miembros',
      courseMaterial: 'Librería del Curso',
      title: 'Titulo',
      actions: 'Acciones',
      currentSelection: 'Seleccion Actual',
      removeSelection: 'Quitar Selección',
      selectAllContent: 'Seleccionar todo el Contenido',
      startPage: 'Pagina Inicial',
      endPage: 'Pagina Final',
      endPageIsLowerThanStartPage: 'Pagina final  es menor que la pagina inicial',
      invalidStartPage: 'Pagina de inicio invalida',
      error: 'Error',
      retrievingEpubInfo: 'Recuperando información del EPUB',
      initialChapter:'Capítulo inicial',
      finalChapter: 'Capítulo final',
      allContent: 'Todo el contenido',
      fromStart: 'Desde {type} {start} hasta el final',
      fromStartToEnd: 'Desde {type} {start} hasta {type} {end}',
      page: 'página',
      send: 'Enviar',
      saved: 'Guardado',
      write: 'Anotación',
      subdeck: 'Sub Baraja',
      showSideBar: 'Mostrar barra',
      hangUp: 'Colgar',
      startCall: 'Iniciando llamada',
      answerCall: 'Contestar Llamada',
      wasMuted: 'Usted ha sido silenciado por el profesor.',
      wasKickouted: 'Usted ha sido expulsado de la llamada',
      wasGrantToCall: 'Usted ahora tiene permiso para realizar la llamada en la clase {className}',
      callError: 'Error de llamada',
      connErrorCall: 'La llamada ha sido finalizada debido a problemas de comunicación.',
      reconnectCall: 'Reconectar a la llamada',
      callWitoutTeacher: 'Te has unido a la llamada. El profesor aún no se ha conectado.',
      callEndedByTeacher: 'El profesor \'{fullName}\' ha salido de la llamada',
      muteCall: 'Silenciar',
      unmuteCall: 'Activar el sonido',
      unMuteCallAll: 'Activar el sonido de todos en esta llamada',
      kick: 'Expulsar',
      kickouted: 'Usuario expulsado de la llamada (click para darle acceso a la llamada)',
      muteCallAll: 'Silenciar a todos en esta llamada',
      lockCall: 'Bloquear la llamada (nadie más puede unirse a esta llamada)',
      unlockCall: 'Desbloquear la llamada (todos los participantes pueden unirse)',
      speakers: 'Altavoz',
      cameraCall: 'Encender/Apagar cámara',
      showVideoScreen: 'Mostrar Llamada',
      infoCall: 'Información de la llamada',
      moderator: 'Moderador',
      infoCallMember: '{callMembers} de {classMembers} participantes',
      memberOfClass: 'Miembros de la clase {classMembers} | En llamada {callMembers}',
      hideSideBar: 'Oculta barra',
      confirmSavePdf: '¿Estás seguro que quieres enviar tu tarea?',
      confirmExit: '¿Estás seguro que quieres cerrar la ventana?',
      noDescription: 'No hay descripción disponible',
      noTitle: 'No hay título disponible',
      exit: 'Salir',
      created: 'Creada: ',
      sent: 'Enviado',
      sendingFeedback: 'Enviando retroalimentación...',
      menu: 'Menú',
      refresh: 'Refrescar',
      type: 'Tipado',
      pageCamel: 'Página',
      zoomIn: 'Acercar',
      zoomOut: 'Alejar',
      print: 'Imprimir',
      otherFilesApp: 'Otros Archivos',
      presentSlide: 'Presentar',
      zipLesson: 'Archivo ZIP',
      deck: 'Baraja',
      reload: 'Recargar',
      applicationLoading: 'Por favor espera mientras la aplicación carga...',
      clean: 'Limpiar',
      ok: 'Ok'
    },
    inactivityTimeout: {
      modalTitle: 'Alerta de sesión',
      modalOption1: 'Estoy aquí',
      modalOption2: 'Cerrar sesión',
      modalBody1: 'Has estado inactivo por un tiempo. Por favor confirma tu estado, de otra forma la sesión se cerrará en:',
      modalBody2: 'Aún estas ahí?'
    },
    footer: {
      termsAndConditions: 'Términos y condiciones',
      aboutUs: 'Acerca de Nosotros',
      privacyPolicy: 'Política de privacidad',
      helpArea: 'Ayuda',
      contactUs: 'Contactanos'
    },
    errors: {
      required: 'Este campo es requerido',
      emailValid: 'El correo electrónico debe ser válido',
      url: 'El formato de la url es inválido',
      maxLength: 'El tamaño del texto está por encima de la longitud máxima.',
      maxLengthData: 'El texto está por encima de la longitud máxima del campo [{max}].',
      minLengthData: 'El texto está por debajo de la longitud mínima del campo [{min}].',
      dropzoneTimeout: 'Lo sentimos, la carga tardó más de lo esperado. ¿Puede intentar de nuevo por favor?',
      errorSaving: 'Lo sentimos, ocurrió un error intentando guardar los cambios, por favor intente de nuevo.',
      ups: 'Oops!',
      uplodingInformation: 'Error enviando la información, por favor intente de nuevo',
      minDateValue: 'La fecha no puede ser menor que {min}',
      minDateCustom: 'La fecha no puede ser menor que: ',
      number: 'Solo números',
      load: 'Ocurrió un error cargando esta sección. Intenta de nuevo.',
      between: 'El número debería estar entre {min} y {max}',
      errorLoading: 'Lo sentimos ocurrió un error intentando cargar la información, intenta de nuevo',
      errorConnCallServer: 'Error intentando conectarse al servidor de llamadas [{reason}]',
      warningTeacherNotInCall: 'Lo sentimos, ningún profesor ha iniciado una llamada para esta clase',
      sipError: 'Lo sentimos, hay problemas de comunicación con el servidor de llamadas.',
      sipGeneralError: 'Lo sentimos, hay problemas en la llamada.',
      errorNoExtensionOnCall: 'Lo sentimos, No hay extensiones disponibles para la conferencia',
      errorCallNotSupported: 'Lo sentimos, este navegador no soporta llamadas. Vuelve a intentarlo con otro navegador o actualizalo. Tu actual versión es ',
      notPermissionsGranted: 'Reinicie la llamada pero otorgue los permisos al dispositivo.',
      maxValue: 'El valor máximo debe ser {max}',
      codes: {
        ERR002: 'Lo sentimos, ocurrió un error intentando guardar los cambios, por favor intente de nuevo.',
        SD001: 'La fecha final debe ser anterior a la fecha final',
        SD002: 'La solicitud del calendario escolar se cruza con otro calendario escola, por favor verifique',
        CS002: 'La fecha de vencimiento es antes de la fecha inicial del folder superior',
        CS003: 'La última fecha para enviar la tarea debe ser mayor o igual a la fecha límite de la tarea',
        CB001 : 'La hora de inicio es inválida',
        CB002 : 'La hora de finalización es inválida',
        CB003 : 'La hora de inicio debe ser antes de la hora de finalización',
        CB004 : 'Día laboral no habilitado en la clase',
        CB005 : 'Esta hora o días tiene conflictos con otros bloques. Por favor verifique.',
        CB006 : 'La clase tiene un horario diferente a la de otra clase',
        CB007 : 'Hay entradas de horario en días laborales que está tratando de eliminar',
        CB008 : 'Este horario tiene bloques fuera del rango seleccionado. Por favor verifique',
        HW001 : 'La tarea ha sido borrada.  Por favor recarguela'
      },
      networkError: 'Lo sentimos, hubo un error de conexión con el servidor.',
      offlineNetworkError: 'Hubo un error de conexión. Seguirá trabajando sin conexión hasta que se restablezca la conexión.',
      tryingReconnect: 'Por favor espere, intentando reconectar.',
      expirationHomework: 'La tarea no se puede editar después de su fecha de vencimiento.',
      manuallyReconnect: 'Haga clic para volver a conectarse, la aplicación no se conectó automáticamente debido inactividad.',
      connectBtn: 'Conectar',
      communicationServer: 'Ha habido un error de comunicación. Acepta para continuar.',
      errorLoadingPublicPM: 'Se presento un error de conexión. Por favor presione el boton Actualizar.',
      errorGetData: 'Lo sentimos, se ha producido un error al intentar obtener los datos. Inténtelo de nuevo.',
      cameraNotAvailable: 'Camara no disponible'
    },
    menu: {
      drafts: 'Borradores',
      myClasses: 'Mis clases',
      courseCreation: 'Creación de curso',
      contentCreation: 'Creación de contenido',
      shareWithMe: 'Compartidos conmigo',
      classes: 'Clases',
      myContent: 'Mi Contenido',
      home: 'Inicio',
      resources: 'Recursos',
      institutions: 'Instituciones',
      purchased: 'Purchased',
      bookstore: 'Tienda',
      tutors: 'Tutores',
      login: 'Iniciar',
      about: 'Nosotros',
      contact: 'Contacto',
      faq: 'FAQ',
      training: 'Entrenamiento',
      myTools: 'Herramientas',
      meetings:'Reuniones',
      calls: 'Llamadas',
      customize:'Personalizar',
      noClasses:'No hay clases',
      tohaina:'Conferencia',
      sharedDocument:'Documento Compartido',
      whiteboard:'Tablero',
      presentationMode: 'Modo Presentación',
      sync: 'Sincronizar',
      present: 'Presentación',
      call:'Llamada',
      join: 'Unirse',
      sheet:'Hoja de Cálculo',
      slide:'Slide',
      popupBlocked: 'La ventana de la reunión ha sido bloqueada por el navegador, por favor habilite las opciones de popup en su configuración',
      courseViewer: 'Visor de Cursos',
      studentReadOnly: 'Solo Lectura',
      onToggle: 'Deshabilite para que los estudiantes editen los documentos',
      offToggle: 'Habilite para que los estudiantes no editen los documentos',
      meetingTools: 'Herramientas',
      transparency: 'Transparencia',
      onTransparencyToggle: 'Deshabilite para no editar el documento',
      offTransparencyToggle: 'Habilite para editar el documento',
      all: 'Todo',
      main: 'Main',
      tasks: 'Tareas',
      menu: 'Menú'
    },
    homeworks: {
      homework:'Tarea de estudiante',
      homeworkPoints:'Número total de problemas',
      homeworkWeight:'Peso de la calificación',
      homeworkPointsMessage: 'Total de puntos de la tarea',
      homeworkWeightMessage: 'Peso de la tarea en el curso',
      homeworkResponseSent: 'Actividad interactiva enviada',
      homeworkResponseView: 'Ver actividad interactiva enviada',
      homeworks: 'Actividades interactivas',
      loadingHomeworks:'Cargando Actividades interactivas',
      alreadyGraded:'Ya calificado',
      setGrade:'Calificar',
      noCoursesWithHomeworks:'No tienes cursos con Actividades interactivas aún',
      addReponse: 'Responder Actividad interactiva',
      noHomeworks: 'Sin Actividades interactivas',
      notHomeworksStudent: 'Este estudiante no tiene actividades por ahora',
      notHomeworksSection: 'Esta actividad interactiva no tiene estudiantes por revisar ahora',
      feedbackSent: 'Comentarios enviados',
      uploadFeedback:'Enviar comentarios',
      studentNotHomeworks: 'No tienes tareas pendientes en este curso',
      byStudents: 'Por estudiantes',
      byActivities: 'Por actividades',
      sendAllAnnotations: 'Enviar con todas las anotaciones',
      sendOnlyMyAnnotations: 'Enviar sólo con mis anotaciones',
      homeworkWithoutAnnotations: 'La tarea aún no tiene anotaciones',
      homeworkOnlyTeacherAnnotations: 'Esta tarea sólo tiene anotaciones de tu profesor. ¿Quieres enviar esta tarea sólo con las anotaciones de tu profesor? ',
      homeworkManyAnnotations: 'Esta tarea no sólo tiene anotaciones tuyas sino también de tu profesor. ¿Qué quieres hacer con estas anotaciones?',
      cantOpenHomework: 'Esta tarea no se puede abrir en esta versión, por favor ábrala en el dispositivo donde la comenzaste',
      annotationsDeleteAll: 'Esta acción eliminara todas las anotaciones. Está seguro que quiere continuar?',
      homeworkDraftNotAvailable: 'El borrador de la tarea no está disponible',
      removeCurrentPage: 'Esta acción eliminará todas las anotaciones que ha realizado hasta ahora sobre la página actual. Quieres proceder?',
      documentStatus: 'Estamos generando su archivo, este proceso puede tardar algunos minutos; por favor consulte mas tarde.',
      disconnected: 'Desconectado',
      empty: 'Sin anotaciones',
      pendingAnswers: 'Tienes respuestas pendientes',
      wip: 'En progreso',
      submitted: 'Enviado',
      noAvailable: 'Tarea no disponible',
      responseDraftStatus: 'Tarea en progreso',
      feedbackDraftStatus: 'Retroalimentación en progreso',
      joinTooltip: 'Haz clic para unirte a la sesión de tarea colaborativa',
      homeworkUpdated: 'Tarea actualizada',
      newHomeworkVersionUploaded: '{fullName} acaba de subir una nueva versión de esta tarea. Tu tablero será recargado',
      someone: 'Alguien',
      homeworkConflictVersion: 'Has estado trabajando sin conexión este dispositivo y detectamos que se realizaron cambios para esta tarea desde otra sesión el día {date}.\n¿Cuáles cambios deseas conservar?',
      remoteVersion: 'Guardar lo que se hizo en otro dispositivo',
      localVersion: 'Mantener la versión de este dispositivo',
      mergeVersions: 'Mezclar ambas versiones',
      waitBackOnline: 'Estás de vuelta en línea. Espere unos segundos mientras lo regresamos a la sesión.',
      homeworkHistory: 'Historial de versiones',
      historyTitle: 'Historial de versiones - {name}',
      historyDisclamer: 'Hay anotaciones pendientes de sincronización. Reabra la tarea para sincronizarlas y habilitar la restauración de versiones.',
      loadingItems: 'Loading items',
      noDataAvailable: 'No data available',
      history: {
        date: 'Fecha',
        source: 'Fuente',
        version: 'Version',
        actions: 'Acciones',
      },
      sourceType: {
        autosave: 'Guardado Automático',
        overwrite: 'Sobrescrito',
        restore: 'Versión restaurada',
        clean_all_annotations: 'Todas las anotaciones eliminadas',
        clean_page_annotations: 'Anotaciones de una página eliminadas',

        web: 'Web',
        uwp: 'Windows',
        ios: 'iOS'
      },
      takeTextEditorControl: 'Editar Texto',
      teacherEditingText: 'El profesor está editando',
      teacher: 'Profesor',
      student: 'Estudiante',
      actionView: 'Vista previa',
      actionRestore: 'Restaurar versión',
      questionActionRestore: 'Está seguro de restaurar el documento a esta versión ?',
      documentRestored: 'El documento fue restaurado correctamente a la versión {versionId}',
      errorTitle: 'Oops!',
      errorDocumentRestored: 'Lo sentimos, hubo un error al intentar restaurar el documento',
      boardsAreSyncing: 'Los tableros se están sincronizando. Por favor espere hasta que terminen y vuelva a intentarlo.',
      boardsHavePendingAnnotations: 'Algunos tableros tienen anotaciones pendientes. Por favor espere hasta que se envíen al servidor y vuelva a intentarlo.',
      conflictResolutionFailed: 'La resolución de conflictos falló. Se volverá a intentar cuando vuelva a estar en línea.',
      includeFeedback: 'Incluir la retro-alimentacion del profesor si está disponible',
      includeProblem: 'Incluir el enunciado del problema',
      reportOptionsTitle: 'Opciones del reporte',
      reportOptionsMessage: 'Por favor seleccione las opciones para generar el reporte',
    },
    teacherPortal: {
      calendar: 'Calendario',
      im: 'IM',
      grades: 'Calificaciones',
      tasks: 'Tareas',
      meetings: 'Reuniones',
      calls: 'Llamadas'
    },
    edupad: {
      synchronizing: 'Sincronizando datos con el servidor',
      errorMessage: 'No fue posible sincronizarse con el servidor colaborativo',
      docDeletedTitle: 'Documento borrado',
      docDeleted: 'El documento ha sido borrado. Por favor recargar la tarea.',
      verificationFailedReconnect: 'Falló la verificacion del usuario.  POr favor reconectese para sincronizar el documento.',
      verificationFailed: 'Falló la verificacion del usuario',
      connectionErrorTitle: 'Error de conexion',
      viewHistory:'Ver historial de versiones',
      networkStatus:'Estado de la red',
      unauthenticatedUser: 'Usuario no autenticado',
      historyTitle: 'Selecciona tu versión',
      chooseVersion: 'Seleccione una versión',
      restore: 'Restablecer',
      restoring: 'Restaurando la versión {version}',
      remoteRestoring: 'El usuario \'{username}\' está restaurando la versión {version}',
      remoteRestored: 'La versión {version} ha sido restaurada por el usuario \'{username}\'',
      errorRestoring: 'No fue posible restaurar la versión seleccionada',
      confirmRestore: 'Al restaurar esta versión, se sobrescribirá la versión actual. ¿Está seguro?',
      noHistory: 'EL documento actual no tiene historial',
      loadingHistory: 'Cargando historial...',
      errorHistory: 'No fue posible recuperar el historial del documento',
      errorHistoryVersion: 'No fue posible recuperar la versión \'{version}\' del documento ',
      erroLoadingMilestones: 'No fue posible recuperar los hitos del documento',
      offline: 'Cargando el documento fuera de linea',
      offlineEnd: 'Nuevamente en linea',
      milestoneAutosaveLabel: 'Autoguardado',
      milestoneRestoredLabel: 'Restaurado',
      milestoneOverridedLabel: 'Sobrescrito',
      milestoneInitial: 'Inicial',
      milestoneCurrent: 'Actual',
      milestoneAutosave: 'Autoguardado el \'{date}\'',
      milestoneOverride: 'Sobrescrito por \'{user}\' el \'{date}\' ',
      milestoneRestore: 'Restaurado por \'{user}\' el \'{date}\'',
      showMilestones: 'Mostrar hitos',
      placeholder: 'Empieza a colaborar...'
    },
    drawItems: {
      pencil: 'Lápiz',
      text: 'Texto',
      pointer: 'Puntero',
      rectangle: 'Rectángulo',
      hand: 'Mano',
      trash: 'Basurero',
      circle: 'Círculo',
      straightLine: 'Línea recta',
      zoom: 'Enfocar',
      opacity: 'Opacidad',
      size: 'Tamaño',
      whiteout: 'Corrector',
      square: 'Cuadrado',
      ellipse: 'Elipse',
      color: 'Color',
      shapes: 'Figuras',
      eraser: 'Borrador',
      undo: 'Deshacer',
      redo: 'Rehacer',
      removeCurrent: 'Borrar página actual',
      removeAll: 'Borrar todo',
      menu: 'Menú'
    },
    breadcrumbs: {
      home: 'Inicio',
      purchased: 'Comprados',
      subjects: 'Cursos',
      books: 'Libros',
      courses: 'Cursos',
      myContent: 'Mi contenido',
      all: 'Todo',
      templates: 'Plantillas'
    },
    error404: {
      404: '404',
      somethingBroken: 'Oops! Algo esta roto.',
      brokenReasons: 'Aquí hay una lista de posibles razones:',
      brokenReason1: 'URL mal escrita',
      brokenReason2: 'Error copiando y pegando',
      brokenReason3: 'Link roto',
      brokenReason4: 'Link truncado',
      brokenReason5: 'Contenido movido',
      brokenReason6: 'Contenido eliminado',
      ifErrorPersists: 'Si el error persiste',
      contactUs: 'contáctenos',
      forSupport: 'para soporte.'
    }
  }
};

export default globalMsg;
